// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_REVIEW = "Pridaj hodnotenie";
export const BLOGS = "Stena";
export const counter_REPLIES = ["%(counter)s odpove\u010f", "%(counter)s odpovede", "%(counter)s odpoved\u00ed"];
export const count_WIKI_ARTICLE_EXPERIENCES = ["%(count)s sk\u00fasenos\u0165", "%(count)s sk\u00fasenosti", "%(count)s sk\u00fasenost\u00ed"];
export const FOLLOW_USER = "Sleduj";
export const FORUM_ADD_QUESTION = "Polo\u017e anonymn\u00fa ot\u00e1zku";
export const FORUM_DEFAULT_TOPIC_NAME = "Nezaraden\u00e9";
export const FORUM_READ_MORE = "\u010c\u00edtaj viac...";
export const HOME_FORUM_DISCUSSION_HINTS_FOOTER = "\u010eal\u0161ie zauj\u00edmav\u00e9 diskusie";
export const HOME_FORUM_DISCUSSION_HINTS_TITLE = "Zauj\u00edmav\u00e9 nezodpovedan\u00e9 najnov\u0161ie diskusie";
export const HOME_FORUM_TOPIC_HINTS_FOOTER = "Vyber in\u00fa kateg\u00f3riu f\u00f3ra";
export const HOME_FORUM_TOPIC_HINTS_TITLE = "Zauj\u00edmav\u00e9 kateg\u00f3rie f\u00f3ra";
export const HOMEPAGE_POST_TYPE_YOUTUBE_MK = "YouTube Modr\u00fd kon\u00edk";
export const JOIN = "Zapoj sa";
export const LATEST = "Najnov\u0161ie";
export const NO_REPLIES = "Nezodpovedan\u00e9";
export const READ_OR_ASK = "\u010c\u00edtaj alebo sa sp\u00fdtaj";
export const REPLY = "Odpovedz";
export const REVIEW_VERIFIED = "Overen\u00e1 recenzia";
export const SEE_CONTESTS = "Pozri si v\u0161etky s\u00fa\u0165a\u017ee";
export const SEO_TITLE_CONTESTS = "S\u00fa\u0165a\u017ee";
export const SEO_TITLE_COUNSELLINGS = "Poradne";
export const SEO_TITLE_FORUM = "F\u00f3ra";
export const SHARE = "Zdie\u013eaj";
export const SUBSCRIBE_TOPIC = "Odoberaj";
export const TOPIC_COUNSELLOR = "Odborn\u00edk";
